import React from 'react'
export const publicRoutes = [
    {
        key: 'financieras',
        path: `/financieras/:id`,
        component: React.lazy(() => import('views/auth-views/formulario')),
    },
]

export const protectedRoutes = []